import Confirmation from "@/components/ui/Confirmation";
import { dangerPreset } from "@/components/ui/Confirmation/Confirmation.presets";
import { ModalState } from "@/types/common";
import { PaymentCard } from "@/features/payment/types";
import useDeletePatientCard from "../hooks/useDeletePatientCard";

interface Props extends ModalState {
  patientId: string;
  practiceId: string;
  patientFullName: string;
  cardOnFile: PaymentCard;
}

const DeletePatientCardConfirmation = ({
  open,
  onClose,
  cardOnFile,
  patientId,
  practiceId,
  patientFullName,
}: Props) => {
  const { deleteCard, isDeletingCard } = useDeletePatientCard({
    onSuccess: onClose,
    patientId,
    practiceId,
  });

  return (
    <Confirmation
      open={open}
      onClose={onClose}
      title="Delete card on file?"
      testId="delete-card-confirmation"
      {...dangerPreset}
      action={{
        ...dangerPreset.action,
        onClick: () => deleteCard(),
        children: "Delete Card",
      }}
      actionLoading={isDeletingCard}
      description={
        <span>
          This will permanently remove{" "}
          <b className="text-content-primary">{patientFullName}'s </b>
          card ending in{" "}
          <b className="text-content-primary">{cardOnFile.last4}</b> from file.
          This action cannot be undone.
        </span>
      }
    />
  );
};

export default DeletePatientCardConfirmation;
